<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div class="columns column6">
					<div class="title-reverse-wrapper">
						<h1>{{ title }}</h1>
						<h2 class="subtitle">{{ subtitle }}</h2>
					</div>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="content" />
					<slot name="extraContent" />
				</div>
			</slot>
			<slot />
		</div>
		<slot name="bgImage">
			<div />
		</slot>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>
